export default __webpack_public_path__ + "static/media/NW0220.34I-42972_-25679_0.873c85e8.jpg";